import { Component, Input } from '@angular/core';
import { Experience, ExperienceShort, Filter } from '../../../services/interfaces/experiences';
import { ActivatedRoute, Router } from '@angular/router';
import { ExperiencesService } from 'app/services/experiences.service';
import { TransparencyService } from 'app/utils/transparency.service';
import { Company } from 'app/services/interfaces/company';
import { CompaniesService } from 'app/services/companies.service';


@Component({
  selector: 'app-territories',
  templateUrl: './territories.component.html',
  styleUrl: './territories.component.scss'
})
export class TerritoriesComponent {

  territoryName: string | null = null;
  
  @Input() experience: Experience | undefined;
  region: string | undefined = "Toscana";

  experiences: ExperienceShort[] = [];
  companies: Company[] = [];
  experienceNum: number| undefined = 195;
  images = [
    { itemImageSrc: 'https://images.unsplash.com/photo-1660071170338-5a7bb51512fd?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' },
    { itemImageSrc: 'https://images.unsplash.com/photo-1633357933248-4805fbc7978b?q=80&w=1770&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' },
    { itemImageSrc: 'https://images.unsplash.com/photo-1633357931616-e3c6a17d4ec6?q=80&w=1920&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' },
    { itemImageSrc: 'https://images.unsplash.com/photo-1628339469395-d9e3f2438e75?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' },
    
  ];
  territoryDescription = 'La Toscana è una delle regioni vitivinicole più prestigiose al mondo, con radici che risalgono agli Etruschi e una tradizione perfezionata nel Medioevo. Caratterizzata da colline, vigneti e borghi storici, è famosa per vini come il Chianti, il Brunello di Montalcino e il Vino Nobile di Montepulciano. Il Sangiovese, uva principale della regione, dona a questi vini il loro carattere distintivo, spesso affiancato da vitigni internazionali come Cabernet Sauvignon e Merlot per creare i rinomati Super Tuscan. La combinazione di clima, suolo e tradizione fa della Toscana un’icona vinicola globale.';
  numberOfExperiences: number = 20;
  LOCALE: string = 'it';
  
  constructor(private route: ActivatedRoute,
    private router: Router,
    private experiencesService: ExperiencesService,
    private transparencyService: TransparencyService,
    private companiesService: CompaniesService
  ){

  }

  ngOnInit(): void {
    this.getMainPageExperiences();
    this.getCompanies();
    this.transparencyService.setTransparency(false);
    // Ottieni il nome del territorio dalla route
    this.route.paramMap.subscribe(params => {
      this.territoryName = params.get('label');
    });
    
    // Imposta wine_region_id da usare nel filtro
    //const wineRegionId = "f762b615-2635-44f3-a7ce-67dc03d3ed93";
  
    // Costruisci il filtro completo
    //const filter: Filter = {
      //size: 10, // o un valore di default
      //page: 1, // o un valore di default
      //lang: 'it', // o un valore di default
    //  wine_region_id: wineRegionId // aggiungi wine_region_id al filtro
   // };
  
    // Esegui la richiesta con il filtro
   // this.experiencesService.list(filter).subscribe({
   //   next: (response) => {
   //     console.log(response);
        // Filtro delle esperienze ricevute in base al wine_region_id
        //this.experiences = response.content.filter(experience => experience.company.wine_region_id === wineRegionId);
  //      this.experiences = response.content;
  //      console.log('Esperienze filtrate:', this.experiences);
  //    },
 //     error: (error) => {
 //       console.error('Errore nel caricamento delle esperienze:', error);
 //     }
 //   });

  }
  async getMainPageExperiences() {
    console.log("Chiamata getMainPageExperiences avviata");
  
    this.experiencesService
      .listCard({ page: 0, size: this.numberOfExperiences, lang: this.LOCALE })
      .subscribe(
        (experiencesPage) => {
          console.log("Risposta ricevuta da listCard:", experiencesPage);
          
          if (experiencesPage && experiencesPage.content) {
            this.experiences = experiencesPage.content;
            console.log("Array completo di esperienze:", this.experiences);
          } else {
            console.log("L'oggetto `experiencesPage` non contiene `content` o è vuoto.");
          }
        },
        (error) => {
          console.error("Errore durante la chiamata API:", error);
        }
      );
  }

  getCompanies(): void {
    console.log("Chiamata getCompanies avviata");
  
    const filter: Filter = {
      page: 1,
      size: 10, 
      lang: 'it'
    };
  
    this.companiesService.getWineryCompany(filter).subscribe({
      next: (companies) => {
        this.companies = companies;
      },
      error: (error) => {
        console.error("Errore durante la chiamata API:", error);
      }
    });
  }
  

  responsiveOptionsExperience = [
    {
      breakpoint: '1470px',
      numVisible: 4,
      numScroll: 4,
    },
    {
      breakpoint: '1000px',
      numVisible: 3,
      numScroll: 3,
    },
    {
      breakpoint: '800px',
      numVisible: 2,
      numScroll: 2,
    },
  ];



  linkToExperience(experienceId: string, experienceName: string) : void{
    this.router.navigate(['/']);
  }
}
